// extracted by mini-css-extract-plugin
export default {"table":"UkXxFo","caption":"ZeyIca","tr":"l6f_ej","th":"TX9hz4","name":"t9sol5","headerRow":"mp2EKE","percentage":"N_QbLI","headerText":"WEqdBG"};